import { OS } from '@cineamo/ui/src/helpers/os-helper';

export function mapLinkMobile(config: { street: string; postalCode?: string; city?: string; os?: OS }): string {
    const { street, postalCode, city, os } = config;
    const addressParts: string = [street?.replace(' ', '+'), city].filter((it) => (it?.length ?? 0) > 0).join(',');
    if (os === OS.iOS) {
        return `maps://?q=${addressParts}${postalCode ? `&z=${postalCode}` : ''}`;
    }
    return `geo:?q=${addressParts}${postalCode ? `&z=${postalCode}` : ''}`;
}

export function mapLinkDefault(config: { street: string; postalCode?: string; city?: string }): string {
    const { street, postalCode, city } = config;
    const addressParts: string = [street?.replace(' ', '+'), city].filter((it) => (it?.length ?? 0) > 0).join(',');
    return `maps://?q=${addressParts}${postalCode ? `&z=${postalCode}` : ''}`;
}
